<div class="sp-tab" *ngIf="subscription">
  <section class="sp-card" aria-labelledby="sp-subscription-title">
    <header class="sp-card__header">
      <span class="sp-card__icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#16801e"><path d="M200-160v-80h560v80H200Zm0-140-51-321q-2 0-4.5.5t-4.5.5q-25 0-42.5-17.5T80-680q0-25 17.5-42.5T140-740q25 0 42.5 17.5T200-680q0 7-1.5 13t-3.5 11l125 56 125-171q-11-8-18-21t-7-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820q0 15-7 28t-18 21l125 171 125-56q-2-5-3.5-11t-1.5-13q0-25 17.5-42.5T820-740q25 0 42.5 17.5T880-680q0 25-17.5 42.5T820-620q-2 0-4.5-.5t-4.5-.5l-51 321H200Z"/></svg>
      </span>
      <h3 class="sp-card__title" id="sp-subscription-title">Subscription</h3>
    </header>
    <dl class="sp-grid">
      <div class="sp-field" *ngIf="planLabel">
        <dt>Plan Name</dt>
        <dd>{{ planLabel }}</dd>
      </div>
      <div class="sp-field">
        <dt>Subscription Status</dt>
        <dd>
          <span class="sp-badge" [ngClass]="'sp-badge--' + subscription.status">{{ statusLabel }}</span>
        </dd>
      </div>
      <div class="sp-field" *ngIf="hasExpiryDate">
        <dt>{{ subscription.status === 'expired' ? 'Expiration Date' : 'Next Renewal Date' }}</dt>
        <dd>{{ subscription.expiryDate | date: dateFormat : 'UTC' }}</dd>
      </div>
      <div class="sp-field" *ngIf="renewalPrice as price">
        <dt>Renewal Amount</dt>
        <dd>
          {{ price.amount | currency: (price.currency | uppercase) : 'symbol' : '1.2-2' }}<span *ngIf="renewalInterval"> / {{ renewalInterval }}</span>
        </dd>
      </div>
    </dl>
  </section>

  <div class="sp-row">
    <section class="sp-card sp-card--half" aria-label="Auto-Renewal">
      <header class="sp-card__header">
        <i class="material-icons sp-card__icon" aria-hidden="true">autorenew</i>
        <h3 class="sp-card__title">Auto-Renewal</h3>
      </header>
      <app-subscription-status [subscription]="subscription" mode="autorenew"></app-subscription-status>
      <p class="sp-muted" *ngIf="subscription.status === 'expired'">
        Auto-Renewal is not available because the subscription has expired.
      </p>
    </section>

    <section class="sp-card sp-card--half" aria-labelledby="sp-payment-title">
      <header class="sp-card__header">
        <i class="material-icons sp-card__icon" aria-hidden="true">attach_money</i>
        <h3 class="sp-card__title" id="sp-payment-title">Payment Information</h3>
      </header>
      <p class="sp-muted" *ngIf="paymentState === 'error'" role="alert">Payment information could not be loaded.</p>
      <dl class="sp-grid">
        <div class="sp-field">
          <dt>Last Payment Amount</dt>
          <dd>
            <ng-container *ngIf="lastPayment; else noPayment">{{ lastPayment.amount | currency: (lastPayment.currency | uppercase) : 'symbol' : '1.2-2' }}</ng-container>
          </dd>
        </div>
        <div class="sp-field">
          <dt>Last Payment Status</dt>
          <dd>
            <span *ngIf="lastPayment; else noPayment" class="sp-badge" [ngClass]="'sp-badge--payment-' + lastPayment.status">{{ paymentLabels[lastPayment.status] }}</span>
          </dd>
        </div>
      </dl>
      <ng-template #noPayment>—</ng-template>
    </section>
  </div>

  <section class="sp-card" aria-labelledby="sp-card-title">
    <header class="sp-card__header">
      <i class="material-icons sp-card__icon" aria-hidden="true">credit_card</i>
      <h3 class="sp-card__title" id="sp-card-title">Card Information</h3>
      <button
        *ngIf="canUpdateCard && (cardState === 'loaded' || cardState === 'empty')"
        type="button"
        class="btn rounded_btn green_btn small_btn px-3 sp-card__action"
        (click)="onUpdateCard()"
      >
        Update Card
      </button>
    </header>
    <p class="sp-muted" *ngIf="cardState === 'error'" role="alert">Card information could not be loaded.</p>
    <p class="sp-muted" *ngIf="cardState === 'empty'">No saved card.</p>
    <dl class="sp-grid" *ngIf="card">
      <div class="sp-field">
        <dt>Card</dt>
        <dd>{{ cardNumberText }}</dd>
      </div>
      <div class="sp-field">
        <dt>Expiration Date</dt>
        <dd>{{ cardExpiryText }}</dd>
      </div>
    </dl>
    <p class="sp-note" *ngIf="card">
      <i class="material-icons sp-note__icon" aria-hidden="true">info</i>
      This card can be updated but not removed while your subscription is active.
    </p>
  </section>
</div>
